import { lazy } from 'react';
import privateRoutes from './private.routes';
import publicRoutes from './public.routes';

// layouts container.
const Layouts = {
    App: lazy(() => import('layouts/app'))
};

// pages container.
const Pages = {
    NotFound: lazy(() => import('pages/not-found'))
};

/**
 * Objeto con la definición de rutas de la aplicación
 */
export default [
    {
        key: 'public-router',
        path: '/',
        DefaultChild: Pages.NotFound,
        routes: publicRoutes
    },
    {
        key: 'private-router',
        path: '/',
        DefaultChild: Pages.NotFound,
        routes: privateRoutes,
        Layout: Layouts.App,
        payload: {
            secured: true,
            footer: {
                text: 'Asociación Chilena de Seguridad / Casa Central: Ramón Carnicer 163, Providencia, Santiago / Call Center: 600 600 22 47'
            }
        }
    }
];
